import AES from '../assets/commonjs/aes'
import axios from 'axios'
import qs from 'qs'
import store from '../store/index'




class API {
  dev = {
    loginUrl: "https://cnapp.cochat.lenovo.com",
    baseUrl: "http://10.99.123.16:8088/app-server",
  }
  pro = {
    loginUrl: "https://cnapp.cochat.lenovo.com",
    baseUrl: "https://microservice.cochat.lenovo.com/app-server",
    // baseUrl: "http://10.96.176.51:8088/app-server"
  }
  // HttpConfigBody = {
  //   _ts: new Date().getTime(), //接口调取的时间
  //   _l: 'zh', //语言
  //   _e: '', //登录接口返回 enterprise 字段
  //   session_id: '', //登录接口返回 session_id 字段
  // };
  // HttpConfigHeader = {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // };


  //登陆接口
  postNode(params) {
    //isTest：true测试环境,false正式环境
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.loginUrl + params.url;

    let data = {
      value: AES.encrypt(JSON.stringify(params.body))
    }
    
    let opt = {
      url,
      method: 'POST',
      data,
      transformRequest: [data => {
        return qs.stringify(data)
      }],
    }
    return axios(opt)
  }

  //checkad
  postCheck(params) {
    console.log(params)
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.loginUrl + "/app_check_user";

    let data = {
      value: AES.encrypt(JSON.stringify(params))
    }

    let opt = {
      url,
      method: 'POST',
      data,
      transformRequest: [data => {
        return qs.stringify(data)
      }],
    }
    return axios(opt)
  }

  //获取融云好友列表
  rongHttp(params) {

    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;

    let encBody = AES.encrypt(JSON.stringify(params))
    let url = req_host.baseUrl + '/getSessionListRy';
    let headers = {
      'value': encBody
    };


    let data = {
      userId: params.userId,
    }

    let opt = {
      url,
      method: 'POST',
      headers,
      data,
      transformRequest: [data => {
        return qs.stringify(data)
      }],
    }
    return axios(opt)
  }

  //获取融云单人聊天记录
  single_conv_Ry(params) {
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.baseUrl + '/selectHistoryMsgRy';
    let header = JSON.parse(JSON.stringify(store.state.login.header))
    header = AES.encrypt(JSON.stringify(header))
    let headers = {
      'value': header
    }
    let fd = new FormData()
    fd.append('userId', params.userId)
    fd.append('recvId', params.recvId)
    fd.append('currIndex', params.currIndex)
    fd.append('pageSize', params.pageSize)
    fd.append('startTime', params.startTime)
    fd.append('endTime', params.endTime)

    let opt = {
      url,
      method: 'POST',
      headers,
      // data: params,
      data: fd,
      // transformRequest: [data => {
      //   return qs.stringify(data)
      // }],
    }

    return axios(opt)
  }

  //获取融云群聊天记录
  group_conv_Ry(params) {
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.baseUrl + '/selectGroupHistoryMsgRy';
    let header = JSON.parse(JSON.stringify(store.state.login.header))
    header = AES.encrypt(JSON.stringify(header))
    let headers = {
      'value': header
    }

    let fd = new FormData()
    fd.append('userId', params.userId)
    fd.append('recvId', params.recvId)
    fd.append('currIndex', params.currIndex)
    fd.append('pageSize', params.pageSize)
    fd.append('startTime', params.startTime)
    fd.append('endTime', params.endTime)

    let opt = {
      url,
      method: 'POST',
      headers,
      data: fd,
    }

    return axios(opt)
  }

  //下载融云单人聊天记录
  download_Ry(params) {
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.baseUrl + '/DownloadHistoryMsgRy';
    let header = JSON.parse(JSON.stringify(store.state.login.header))
    header = AES.encrypt(JSON.stringify(header))
    let headers = {
      'value': header
    }

    return axios.get(url, {
      headers,
      params: {
        userId: params.userId,
        recvId: params.recvId,
        startTime: params.startTime,
        endTime: params.endTime
      }
    })
  }
  //下载融云群聊天记录
  download_group_Ry(params) {
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.baseUrl + '/DownloadGroupHistoryMsgRy';
    let header = JSON.parse(JSON.stringify(store.state.login.header))
    header = AES.encrypt(JSON.stringify(header))
    let headers = {
      'value': header
    }

    return axios.get(url, {
      headers,
      params: {
        userId: params.userId,
        recvId: params.recvId,
        startTime: params.startTime,
        endTime: params.endTime
      }
    })
  }

  //获取极光好友列表
  guangHttp(params) {
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;

    let encBody = AES.encrypt(JSON.stringify(params))
    let url = req_host.baseUrl + '/getSessionList';
    let headers = {
      'value': encBody
    };


    let data = {
      userId: params.userId,
    }

    let opt = {
      url,
      method: 'POST',
      headers,
      data,
      transformRequest: [data => {
        return qs.stringify(data)
      }],
    }
    return axios(opt)
  }
  //获取极光单人聊天记录
  single_conv_jg(params) {
    // console.log(params)
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.baseUrl + '/selectHistoryMsgJG';
    let header = JSON.parse(JSON.stringify(store.state.login.header))
    header = AES.encrypt(JSON.stringify(header))
    let headers = {
      'value': header
    }

    let fd = new FormData()
    fd.append('userId', params.userId)
    fd.append('recvId', params.recvId)
    fd.append('currIndex', params.currIndex)
    fd.append('pageSize', params.pageSize)
    fd.append('startTime', params.startTime)
    fd.append('endTime', params.endTime)
    let opt = {
      url,
      method: 'POST',
      headers,
      // data: params,
      data: fd,
      // transformRequest: [data => {
      //   return qs.stringify(data)
      // }],
    }
    return axios(opt)
  }
  //获取极光群聊天记录
  group_conv_jg(params) {
    // console.log(params)
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.baseUrl + '/selectGroupHistoryMsgJG';
    let header = JSON.parse(JSON.stringify(store.state.login.header))
    header = AES.encrypt(JSON.stringify(header))
    let headers = {
      'value': header
    }
    let fd = new FormData()
    fd.append('userId', params.userId)
    fd.append('recvId', params.recvId)
    fd.append('currIndex', params.currIndex)
    fd.append('pageSize', params.pageSize)
    fd.append('startTime', params.startTime)
    fd.append('endTime', params.endTime)

    let opt = {
      url,
      method: 'POST',
      headers,
      data: fd,
    }

    return axios(opt)
  }

  //下载极光单人聊天记录
  download_Jg(params) {
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.baseUrl + '/DownloadHistoryMsgJg';
    let header = JSON.parse(JSON.stringify(store.state.login.header))
    header = AES.encrypt(JSON.stringify(header))
    let headers = {
      'value': header
    }

    return axios.get(url, {
      headers,
      params: {
        userId: params.userId,
        recvId: params.recvId,
        startTime: params.startTime,
        endTime: params.endTime
      }
    })
  }

  //下载极光群聊天记录
  download_group_Jg(params) {
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;
    let url = req_host.baseUrl + '/DownloadGroupHistoryMsgJg';
    let header = JSON.parse(JSON.stringify(store.state.login.header))
    header = AES.encrypt(JSON.stringify(header))
    let headers = {
      'value': header
    }

    return axios.get(url, {
      headers,
      params: {
        userId: params.userId,
        recvId: params.recvId,
        startTime: params.startTime,
        endTime: params.endTime
      }
    })
  }


  //获取头像
  head_url(params) {

    let url = 'https://microservice.cochat.lenovo.com' + '/image-server/v1.0/chatHead';
    let header = JSON.parse(JSON.stringify(store.state.login.header))
    // console.log(header)

    let headers = {
      'value': AES.encrypt(JSON.stringify(header)),
    }

    // console.log(params)
    return axios.get(url, {
      headers,
      params: {
        session_id: header.sessionId,
        keys: params,
        userId: header.itcode
      }
    })

  }

  //获取群成员
  get_group_member(params) {
    let isTest = false;
    let req_host = isTest ? this.dev : this.pro;

    let header = JSON.parse(JSON.stringify(store.state.login.header))
    header = AES.encrypt(JSON.stringify(header))

    let url = req_host.baseUrl + '/getGroupNumber ';
    let headers = {
      'value': header,
      'Content-Type': 'application/json'
    };

    let data = {
      groupId: params,
      itcode: store.state.login.header.userId
    }

    data = JSON.stringify(data)

    let opt = {
      url,
      method: 'POST',
      headers,
      data,

    }
    return axios(opt)
  }

  group_head_url() {

  }

}


export default new API();



// WEBPACK FOOTER //
// ./src/api/index.js